<template>
  <i-select v-model="_perPage" label="表示件数" size="small" style="width:100px; text-align: left;">
    <template v-for="item in selPerPage">
      <i-option :value="item.value" :key="item.value">{{ item.label }}</i-option>
    </template>
  </i-select>
</template>

<script>
import PerPage from '@/constants/per_page'
import { Select, Option } from 'view-design'
export default {
  components: {
    'i-select': Select,
    'i-option': Option,
  },
  data() {
    return {
      selPerPage: PerPage,
    }
  },
  props: {
    perPage: {
      type: Number,
      default: 20,
      required: true,
    },
  },
  computed: {
    _perPage: {
      get() {
        return this.perPage
      },
      set(val) {
        this.$emit('update:perPage', val)
      },
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped></style>
